import {CircularProgress} from "@material-ui/core";

export const LoadingComponent = ({loading}) => {
    return <>
        {loading && <div style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#0000009e', color: 'white', zIndex: '99999'}}><CircularProgress size={200} thickness={6} color="white" /></div>}
    </>
}
